export enum EAction {
    Initialization = '@tariffBuilder/initialization',
    Initialized = '@tariffBuilder/initialized',
    Finalization = '@tariffBuilder/finalization',
    Loading = '@tariffBuilder/set/loading',

    SetStep = '@tariffBuilder/step/set',

    SelectSpeed = '@tariffBuilder/speed/select',

    AddEntity = '@tariffBuilder/entity/select',
    RemoveEntity = '@tariffBuilder/entity/remove',
    AddTvEntity = '@tariffBuilder/entity/select/tv',
    RemoveTvEntity = '@tariffBuilder/entity/remove/tv',
    RemoveAllTvEntities = '@tariffBuilder/entity/remove/tv/all',
    IncrementEntity = '@tariffBuilder/entity/increment',
    DecrementEntity = '@tariffBuilder/entity/decrement',

    toggleHasSmartTv = '@tariffBuilder/entity/toggleHasSmartTv',
    flushDecoders = '@tariffBuilder/decoders/flushSelected',

    ChangeCost = '@tariffBuilder/entity/changeCost',

    SetClientName = '@tariffBuilder/client/SetClientName',
    SetClientPhone = '@tariffBuilder/client/SetClientPhone',

    SetSelectedTimeSlot = '@tariffBuilder/SetSelectedTimeSlot',
    SetSpeedRestrictions = '@tariffBuilder/client/SetSpeedRestrictions',

    SetAgreementData = '@tariffBuilder/SetAgreementData',

    SetCurrentTariff = '@tariffBuilder/currentTariff/set',
    SetClientContactPhone = '@tariffBuilder/clientContactPhone/set',
    SetChangePlanWebcabData = '@tariffBuilder/changePlanWebcabData/set',
    SetRequestId = '@tariffBuilder/requestId/set',
    SetReplanIsError = '@tariffBuilder/replanIsError/set',
}
